import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import { ProjectDataForm, ProjectFilters } from '../../models/Project';

const useProjectService = () => {
  const { doGet, doPost, doPut, doDelete } = useFetch();

  const [fetchingGetProjects, setFetchingGetProjects] = useState(false);
  const [fetchingShowProject, setFetchingShowProject] = useState(false);
  const [fetchingCreateProject, setFetchingCreateProject] = useState(false);
  const [fetchingStoreProject, setFetchingStoreProject] = useState(false);
  const [fetchingEditProject, setFetchingEditProject] = useState(false);
  const [fetchingUpdateProject, setFetchingUpdateProject] = useState(false);
  const [fetchingDeleteProject, setFetchingDeleteProject] = useState(false);
  const [fetchingActiveProject, setFetchingActiveProject] = useState(false);
  const [fetchingChangeStatusProject, setFetchingChangeStatusProject] = useState(false);

  const getProjects = (filters: ProjectFilters, events: ServiceEvents = {}) => {
    const queryString = Object.entries(filters).map(([k, v]) => `${k}=${v}`).join('&');
    doGet({ ...events, url: `${EndPoints.PROJECTS.GET_PROJECTS}?${queryString}`, setFetching: setFetchingGetProjects });
  };

  const createProject = (events: ServiceEvents = {}) =>
    doGet({ ...events, url: EndPoints.PROJECTS.CREATE_PROJECT, setFetching: setFetchingCreateProject });

  // const showProject = (id: number, events: ServiceEvents = {}) =>
  //   doGet({ ...events, url: EndPoints.PROJECTS.SHOW_PROJECT.replace(':id', id.toString()), setFetching: setFetchingShowProject });

  const storeProject = (data: ProjectDataForm, events: ServiceEvents = {}) =>
    doPost({
      ...events,
      url: EndPoints.PROJECTS.STORE_PROJECT,
      body: data,
      requestType: 'json',
      headers: { 'Content-Type': 'application/json' },
      setFetching: setFetchingStoreProject
    });

  const editProject = (id: number, events: ServiceEvents = {}) =>
    doGet({ ...events, url: EndPoints.PROJECTS.EDIT_PROJECT.replace(':id', id.toString()), setFetching: setFetchingEditProject });

  const updateProject = (id: number, data: ProjectDataForm, events: ServiceEvents = {}) =>
    doPut({
      ...events,
      url: EndPoints.PROJECTS.UPDATE_PROJECT.replace(':id', id.toString()),
      body: data,
      requestType: 'json',
      headers: { 'Content-Type': 'application/json' },
      setFetching: setFetchingUpdateProject
    });

  const deleteProject = (id: number, events: ServiceEvents = {}) =>
    doDelete({ ...events, url: EndPoints.PROJECTS.DELETE_PROJECT.replace(':id', id.toString()), setFetching: setFetchingDeleteProject });

  const activeProject = (id: number, active: boolean, events: ServiceEvents = {}) =>
    doPost({ ...events, url: EndPoints.PROJECTS.ACTIVE_PROJECT.replace(':id', id.toString()), body: { active }, setFetching: setFetchingActiveProject });

  const changeProjectStatus = (id: number, status: string, events: ServiceEvents = {}) =>
    doPut({ 
      ...events, 
      url: EndPoints.PROJECTS.CHANGE_STATUS_PROJECT.replace(':id', id.toString()), 
      body: { status }, 
      setFetching: setFetchingChangeStatusProject 
    });

  return {
    fetchingGetProjects,
    fetchingShowProject,
    fetchingCreateProject,
    fetchingStoreProject,
    fetchingEditProject,
    fetchingUpdateProject,
    fetchingDeleteProject,
    fetchingActiveProject,
    fetchingChangeStatusProject,
    getProjects,
    // showProject,
    createProject,
    storeProject,
    editProject,
    updateProject,
    deleteProject,
    activeProject,
    changeProjectStatus,
  };
};

export default useProjectService;